// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {TrainingRoomGroup} from "@models";
import {SimSystemService, SimTrainingRoomService} from "@services";
import {VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-room-group-chip-input",
	templateUrl: "./sim-room-group-chip-input.component.html",
	styleUrls: ["./sim-room-group-chip-input.component.scss"],
	standalone: false,
})
export class SimRoomGroupChipInputComponent {
	@Input() roomGroupFc: FormArray<FormControl<TrainingRoomGroup>>;
	@Input() label: string;
	@Input() placeholder: string;

	@Input() canSelectMultipleRoomGroups = false;

	optionSelected = output<TrainingRoomGroup>();

	autoCompleteData: VMAutoCompleteNormal<TrainingRoomGroup>[] = [];

	private _availableTrainingRoomGroups: TrainingRoomGroup[] = [];

	constructor(
		private _simSystemService: SimSystemService,
		protected _simTrainingRoomService: SimTrainingRoomService,
	) {
		this._simTrainingRoomService.getTrainingRoomGroups().then((roomGroups) => {
			this._availableTrainingRoomGroups = roomGroups;
			this.reloadAutoCompleteData("");
		});
	}

	reloadAutoCompleteData(searchString: string) {
		this.autoCompleteData = this._availableTrainingRoomGroups
			.filter((g) => g.name.toLowerCase().includes(searchString.toLowerCase()))
			.map((g) => ({
				displayName: g.name,
				value: g,
			}));
	}
}
